import { render, staticRenderFns } from "./BdBatchRouteUpdate.vue?vue&type=template&id=e00ca0bc&"
import script from "./BdBatchRouteUpdate.vue?vue&type=script&lang=js&"
export * from "./BdBatchRouteUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports